import A from './components/A';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const Discharge = () => {
    const { t } = useLang('discharge');
    return (
        <div className={`${css.page}`}>
            <div className="discharge-title">{t('title')}</div>
            <A />
        </div>
    );
};
export default Discharge;
